import React, { createElement } from "react";
import Box from "@mui/joy/Box";
import Paper from "@mui/material/Paper";
import Stack from "@mui/joy/Stack";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Unstable_Grid2";

import PostImage from "./PostImage";
import { defaultExclusions as tagExclusions } from "./defaultExclusions";
import { useTheme } from "@mui/material";
import PostTitle from "./PostTitle";
import TagIcon from "Tag";
import PostDetails from "./PostDetails";

import { useGetPostByIdQuery } from "services/post/postApi";
import { Tag } from "constructs/Tag";
import { useParams } from "react-router-dom";
import ResourceLinks from "shared/ResourceLinks";

const topSorts = ["General", "Ero"];

interface PostProps {
  slug?: boolean | undefined;
  id?: number | undefined;
}

const Post = (props: PostProps) => {
  const theme = useTheme();
  const { postId } = useParams();
  const { data, error, isLoading } = useGetPostByIdQuery(
    { id: props.id ?? postId ?? 0 },
    {
      skip: typeof props.id === "undefined" && typeof postId === "undefined",
    }
  );

  const [spoilerLevel, toggleSpoilerLevel] = React.useState(5);

  // const { kind, published, contributors, image, tags } = props;

  if (isLoading) {
    return null;
  }

  if (!data) {
    return null;
  }

  const { body, kind, published, image, tags, snapshot } = data;
  const contributors: string[] = [];

  return (
    <Paper>
      <Grid spacing={2} columnGap={2}>
        <PostTitle post={data} />
        <Grid container xs={12} spacing={2} justifyContent="center">
          <Grid xs={6}>
            <Typography>
              {new Date(published).toLocaleString(undefined, {
                year: "numeric",
                month: "short",
                day: "numeric",
                hour: "numeric",
                minute: "numeric",
              })}
            </Typography>
          </Grid>
          <Grid xs={6}>
            <Stack direction="row">
              {/* { contributors.map((contributor => contributor)) } */}
              {contributors.join(", ")}
            </Stack>
          </Grid>
        </Grid>
        <Grid container xs={12} justifyContent="center">
          {!data.image || !data.image.uri ? null : (
            <Box
              width={"50%"}
              sx={{
                border: `4px solid ${theme.palette.secondary.dark}`,
                borderRadius: "10px",
                overflow: "hidden",
              }}
            >
              <PostImage
                image={image}
                obfuscationMethod={40}
                tagExclusions={tagExclusions}
              />
            </Box>
          )}
        </Grid>
        {kind === "release" ? <PostDetails post={data} /> : null}
        <Grid xs={12} textAlign="start" sx={{ margin: 2 }}>
          {props.slug
            ? snapshot
            : body.map((section, index) => {
                const children =
                  typeof section.node === "string"
                    ? section.node
                    : createElement(
                        section.node.element,
                        { className: section.node.className },
                        ""
                      );

                return createElement(
                  section.element,
                  { className: section.className, key: index },
                  children
                );
              })}
        </Grid>

        <ResourceLinks resources={data.resourceUris} />

        <Grid container xs={12} m={1}>
          <Stack direction="row" spacing={1} flexWrap="wrap">
            {/* <TransitionGroup> */}
            {tags
              .filter(
                (tag: Tag) => !tag.spoiler || !(tag.spoiler >= spoilerLevel)
              )
              .sort((a, b) => a.name.localeCompare(b.name))
              .sort((a, b) => b.magnitude - a.magnitude)
              .sort((a, b) => {
                if (topSorts.includes(b.name)) {
                  return 1;
                } else return -1;
              })
              .map((tag) => (
                <TagIcon key={tag.id} tag={tag} />
              ))}
            {/* </TransitionGroup> */}
          </Stack>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default Post;
